module.exports = __webpack_public_path__ + "static/media/logo-kiper.520dfe08.svg";